import axios from "axios";

const { REACT_APP_BACKEND_API_URL } = process.env;

export const apiUserUpdateProfile = async (authToken: string, payload: any) => {
  try {
    const url = `${REACT_APP_BACKEND_API_URL}/users/update-profile`;
    const response = await axios.post(url, payload, { headers: { Authorization: `Bearer ${authToken}` } });
    return response?.data;
  } catch (e: any) {
    throw e?.response?.data ? e?.response?.data : e;
  }
};
